import { ImageSet } from 'adaptivecards';

const render = () => {
    const prototypeImageSetRender = ImageSet.prototype.render;
    ImageSet.prototype.render = function () {
        const renderedElement = prototypeImageSetRender.call(this);
        if (renderedElement) {
            renderedElement.style.overflow = 'auto';
        }
        return renderedElement;
    };
};

export const initialize = () => {
    render();
};
